import { CSSProperties, useMemo } from "react";
import { useTheme } from "@nivo/core";
import { observer } from "mobx-react-lite";
import { store } from "../store";

interface CrosshairLineProps {
  innerHeight: number;
}

export const CrosshairLine = observer(({ innerHeight }: CrosshairLineProps) => {
  const theme = useTheme();
  const style = useMemo(
    () => ({
      ...theme.crosshair.line,
      pointerEvents: "none" as CSSProperties["pointerEvents"],
    }),
    [theme.crosshair.line]
  );

  const props = {
    x1: store.x,
    x2: store.x,
    y1: 0,
    y2: innerHeight,
  };

  return <line {...props} fill="none" style={style as any} />;
});
